import { normalizeMultilineAddress } from './multiline-address-normalize-value';
export const multilineAddressViewer = {
    normalizeLoadedValue: normalizeMultilineAddress
};

//# sourceMappingURL=definition-viewer.js.map